export default __webpack_public_path__ + "static/media/logo-bank-8.0afdbc80.png";